<template>
    <q-btn flat dense class="ma-0" size="sm">
        {{ label }}{{ displayLabel }}
        <q-icon size="sm">mdi-menu-down</q-icon>
        <q-menu anchor="bottom left" self="top left" :offset="[0, 8]">
            <q-list dense>
                <q-item
                    v-for="(item, idx) in items"
                    :key="item.value"
                    clickable
                    v-ripple
                    dense
                    class="mediumdense"
                    :active="selection === idx"
                    @click="selection = idx"
                >
                    <q-item-section>
                        <q-item-label>{{ item.flat || item.text }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </q-menu>
    </q-btn>
</template>

<script>
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                selection: 0,
            }
        },
        props: {
            label: String,
            items: Array,
            value: Number,
        },
        computed: {
            displayLabel() {
                const item = this.items?.[this.selection];
                return item?.flat || item?.text || this.Translate('Not selected');
            },
        },
        methods: {
            ...methods,
        },
        watch: {
            selection: function (newv) {
                this.$emit('input', newv);
                this.$emit('update:modelValue', newv);
            },
            value: function (newv) {
                if (newv !== undefined && newv !== null && newv !== this.selection) {
                    this.selection = newv;
                }
            },
        },
        created() {
            if (this.value !== undefined && this.value !== null) {
                this.selection = this.value;
            }
        },
    }
</script>

<style scoped>

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

</style>
